import {
  GET_COUPON_DETAIL_LIST_REQUEST,
  GET_COUPON_DETAIL_LIST_RESPONSE,
  ADD_COUPON_DETAIL_REQUEST,
  ADD_COUPON_DETAIL_RESPONSE,
  UPDATE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_REQUEST,
  UPDATE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_RESPONSE,
  DELETE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_REQUEST,
  DELETE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_RESPONSE,
  UPDATE_COUPON_DETAIL_STATUS_BY_COUPON_DETAIL_ID_REQUEST,
  UPDATE_COUPON_DETAIL_STATUS_BY_COUPON_DETAIL_ID_RESPONSE,
} from "./actionTypes";

export const getCouponDetailListRequest = () => {
  return {
    type: GET_COUPON_DETAIL_LIST_REQUEST,
  };
};

export const getCouponDetailListResponse = (apiResponse) => {
  return {
    type: GET_COUPON_DETAIL_LIST_RESPONSE,
    payload: { apiResponse },
  };
};

export const addCouponDetailRequest = (data) => {
  return {
    type: ADD_COUPON_DETAIL_REQUEST,
    payload: { data },
  };
};

export const addCouponDetailResponse = (apiResponse) => {
  return {
    type: ADD_COUPON_DETAIL_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateCouponDetailByCouponDetailIdRequest = (
  couponDetailId,
  data
) => {
  return {
    type: UPDATE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_REQUEST,
    payload: { couponDetailId, data },
  };
};

export const updateCouponDetailByCouponDetailIdResponse = (apiResponse) => {
  return {
    type: UPDATE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const updateCouponDetailStatusByCouponDetailIdRequest = (
  couponDetailId,
  status
) => {
  return {
    type: UPDATE_COUPON_DETAIL_STATUS_BY_COUPON_DETAIL_ID_REQUEST,
    payload: { couponDetailId, status },
  };
};

export const updateCouponDetailStatusByCouponDetailIdResponse = (
  apiResponse
) => {
  return {
    type: UPDATE_COUPON_DETAIL_STATUS_BY_COUPON_DETAIL_ID_RESPONSE,
    payload: { apiResponse },
  };
};

export const deleteCouponDetailByCouponDetailIdRequest = (couponDetailId) => {
  return {
    type: DELETE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_REQUEST,
    payload: { couponDetailId },
  };
};

export const deleteCouponDetailByCouponDetailIdResponse = (apiResponse) => {
  return {
    type: DELETE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_RESPONSE,
    payload: { apiResponse },
  };
};
